// extracted by mini-css-extract-plugin
export var checkoutRateBadge = "_so-0";
export var checkoutRateBadgeLink = "_so-1";